import React from 'react';
import { config } from "util/config";
import { Image } from 'antd';
import { httpClient } from "util/Api";

export default class CustomImage extends React.Component {
  // 全局缓存：key = `${srcType}:${src}` -> blobUrl
  static blobCache = new Map();

  constructor(props) {
    super();
    this.state = {
      hover: false,
      blobUrl: props.srcType === 'DocumentId'
        ? (CustomImage.blobCache.get(`DocumentId:${props.src}`) || config.component.Image.fallback)
        : config.component.Image.fallback
    };
    this._isMounted = false;
  }

  componentDidMount() {
    this._isMounted = true;
    this.ensureBlobUrl(this.props);
  }

  componentDidUpdate(prevProps) {
    // 如果真的换了图片源，才更新
    if (
      prevProps.srcType !== this.props.srcType ||
      prevProps.src !== this.props.src
    ) {
      this.ensureBlobUrl(this.props);
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
    // 如需严格释放，可在这里选择性 revokeObjectURL，
    // 但如果还会复用缓存的 URL，就不要 revoke。
    // const key = `${this.props.srcType}:${this.props.src}`;
    // const url = CustomImage.blobCache.get(key);
    // URL.revokeObjectURL(url);
    // CustomImage.blobCache.delete(key);
  }

  // 只有在缓存没有时才会请求；有缓存直接使用，不刷新不请求
  ensureBlobUrl = (props) => {
    const { srcType, src } = props;

    if (srcType !== 'DocumentId') {
      // 非 DocumentId，直接显示 src
      if (this._isMounted) this.setState({ blobUrl: src || config.component.Image.fallback });
      return;
    }

    const cacheKey = `DocumentId:${src}`;
    const cached = CustomImage.blobCache.get(cacheKey);
    if (cached) {
      if (this._isMounted) this.setState({ blobUrl: cached });
      return;
    }

    // 无缓存才请求
    const url = '/Business/Document/Download/' + src;
    httpClient({
      method: 'get',
      url,
      responseType: 'blob'
    })
      .then(({ data }) => {
        if (!this._isMounted) return;
        const blobUrl = URL.createObjectURL(data);
        CustomImage.blobCache.set(cacheKey, blobUrl);
        this.setState({ blobUrl });
      })
      .catch(() => {
        if (this._isMounted) this.setState({ blobUrl: config.component.Image.fallback });
      });
  };

  // 关键：只有在图片源变化、hover 变化、blobUrl 首次就绪时才允许重渲染
  shouldComponentUpdate(nextProps, nextState) {
    if (this.props.srcType !== nextProps.srcType) return true;
    if (this.props.src !== nextProps.src) return true;
    if (this.state.blobUrl !== nextState.blobUrl) return true;
    if (this.state.hover !== nextState.hover) return true;
    return false; // 其余变更一律忽略（例如父组件的 columns 切换）
  }

  render() {
    const { divClassName, imageClassName, buttons, srcType, src } = this.props;
    const { blobUrl, hover } = this.state;

    const finalSrc = srcType === 'DocumentId' ? blobUrl : src;

    return (
      <div
        className={divClassName}
        onMouseEnter={() => this.setState({ hover: true })}
        onMouseLeave={() => this.setState({ hover: false })}
      >
        <Image
          className={imageClassName}
          src={finalSrc}
          fallback={config.component.Image.fallback}
          // 为了避免图片内部重挂载，尽量不要给 <Image> 变化的 key
        />
        {hover ? <div className='image-button-div'>{buttons}</div> : null}
      </div>
    );
  }
}
